import Module from 'modules/Module';
import InsightReportsPage from './pages/InsightReportsPage';
import WebsiteTrafficReporting from './pages/WebsiteTrafficReporting';
import UsersReporting from './pages/UsersReporting';
import P from 'router/paths';
import Alert from 'components/Dialogs/Alert';
import WebsitesSelect from 'components/Selects/WebsitesSelect';
import useWebsites from 'modules/website/hooks/useWebsites';
import { Card } from 'antd';
import useQueryParams from 'hooks/useQueryParams';
import { useEffect } from 'react';
import useWorkspace from 'store/redux/hooks/useWorkspace';

const ReportModule = () => {
  const { websites } = useWebsites();
  const { workspace } = useWorkspace();
  const { setUrlParams, searchParams } = useQueryParams();
  const selected_website_id = localStorage.getItem(`selected_website_id_${workspace.id}`);
  let { website_id = selected_website_id } = searchParams;

  useEffect(() => {
    if (!website_id && websites?.length && workspace.id) {
      const firstVerified = websites.find((w) => w.verified);
      if (firstVerified) {
        website_id = firstVerified.id;
        localStorage.setItem(`selected_website_id_${workspace.id}`, firstVerified.id);
        setUrlParams({ website_id: firstVerified.id });
      }
    }
  }, [websites, workspace.id, selected_website_id, website_id, setUrlParams]);

  const module = new Module({
    routes: [
      { path: P.REPORT.INDEX, exact: true, component: WebsiteTrafficReporting },
      { path: P.REPORT.USERS, exact: true, component: UsersReporting },
      { path: P.REPORT.USER_JOURNEY, exact: true, component: InsightReportsPage },
    ],
  });

  return (
    <>
      {website_id || selected_website_id ? (
        module.render()
      ) : (
        <div className='relative w-full h-full'>
          <div className='w-full h-full' style={{ filter: 'blur(2px)' }}>
            {module.render()}
          </div>

          <div
            className='absolute inset-0 rounded-md z-10'
            style={{ background: 'rgba(245, 245, 245, 0.43)' }}
          />

          <div className='absolute inset-0 flex justify-center items-start pt-[10%] z-20'>
            <Card className='!h-fit shadow-2xl m-4'>
              <div className='grid gap-2'>
                <Alert
                  closable={false}
                  type='warning'
                  showIcon
                  description={
                    <span className='text-xs'>
                      Please select a website to view the traffic report.
                    </span>
                  }
                />
                <WebsitesSelect
                  className='w-full'
                  defaultValue={website_id || selected_website_id}
                  onChange={(val) => {
                    localStorage.setItem('selected_website_id', val);
                    setUrlParams({ website_id: val });
                  }}
                />
              </div>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportModule;
